<template>
  <ButtonTooltip
    text
    icon
    :x-small="$vuetify.breakpoint.xsOnly || $device.isIos"
    :tooltip-props="{
      top: true,
      bottom: false,
      nudgeTop: '11',
      transition: 'none',
      disabled: !$vuetify.breakpoint.mdAndUp || $device.isIos,
    }"
    v-bind="$attrs"
    :icon-name="iconName"
    button-class="white--text"
    v-on="$listeners"
  >
    <slot></slot>
  </ButtonTooltip>
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"
export default {
  name: "PlayerActionButton",
  components: { ButtonTooltip },
  props: {
    iconName: {
      type: String,
      default: "",
    },
  },
}
</script>
